// Components/Services/ADUAndCustomHomes/ADUAndCustomHomesPage.jsx
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import ADUHeroSection from "./ADUHeroSection";
import Overview from "./OverView";
import WhoItsFor from "./WhoItsFor";
import ADUPortfolio from "./ADUPortfolio";
import WhoWeAre from "../AboutUs/WhoWeAre";
import FinalCTA from "../HomePage/FinalCTA";
import ProcessSection from "./ProcessSection";
import HomeRemodelOverview from "../FullHomeRemodel/HomeRemodelOverview";
import HOACommercialOverview from "../HOACommercial/HOACommercialOverview";
import TakeoverProjectsOverview from "../TakeoverProjects/TakeoverProjectsOverview";
import HomeRemodelPortfolio from "../FullHomeRemodel/HomeRemodelPortfolio";
import ADUOtherServicesSection from "./ADUOtherServicesSection";
import HOAPortfolio from "../HOACommercial/HOAPortfolio";


export default function ADUAndCustomHomesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>ADUs & Ground-Up Custom Homes | Ashlar Building Group</title>
        <meta
          name="description"
          content="Ashlar Building Group builds permitted ADUs and fully custom ground-up homes across California. Detached units, garage conversions, and custom builds — handled A-to-Z by a third-generation construction firm."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.ashlarbuildinggroup.com/services/custom-homes" />

        {/* Open Graph */}
        <meta property="og:title" content="ADUs & Ground-Up Custom Homes | Ashlar Building Group" />
        <meta
          property="og:description"
          content="From accessory dwelling units and garage conversions to fully custom ground-up builds — Ashlar handles design, permits, and construction with zero shortcuts."
        />
        <meta property="og:image" content="/Images/Ground-Up-custom.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.ashlarbuildinggroup.com/services/custom-homes" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ADUs & Ground-Up Custom Homes | Ashlar Building Group" />
        <meta
          name="twitter:description"
          content="Permitted ADUs, garage conversions, and fully custom ground-up homes built by a third-generation California contractor."
        />
        <meta name="twitter:image" content="/Images/Ground-Up-custom.png" />

        {/* Schema — LocalBusiness */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "HomeAndConstructionBusiness",
            "name": "Ashlar Building Group",
            "url": "https://www.ashlarbuildinggroup.com",
            "logo": "https://www.ashlarbuildinggroup.com/Images/logo.png",
            "image": "https://www.ashlarbuildinggroup.com/Images/Ground-Up-custom.png",
            "description": "Third-generation California general contractor specializing in ADUs, ground-up custom homes, and full home remodels.",
            "telephone": "+19256557741",
            "email": "info@ashlarbuilding.com",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "6200 Stoneridge Mall Rd",
              "addressLocality": "Pleasanton",
              "addressRegion": "CA",
              "postalCode": "94588",
              "addressCountry": "US"
            },
            "areaServed": ["Bay Area", "Orange County", "Los Angeles", "San Diego"],
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "ADU & Custom Home Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Detached ADU Construction",
                    "description": "Fully permitted detached accessory dwelling units built from ground up."
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Garage Conversion ADU",
                    "description": "Convert existing garage into a permitted livable ADU unit."
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Ground-Up Custom Home",
                    "description": "Fully custom designed and built homes from foundation to finish."
                  }
                }
              ]
            }
          }
        `}</script>
      </Helmet>

      <ADUHeroSection />
      <Overview />
      <ADUPortfolio />
      <WhoItsFor />
     <ProcessSection/>
     <ADUOtherServicesSection/>
     <HomeRemodelOverview/>
     <HomeRemodelPortfolio/>
     <HOACommercialOverview/>
     <HOAPortfolio/>
   <TakeoverProjectsOverview/>
      <WhoWeAre />
      <FinalCTA />
    </>
  );
}